// import clsx from 'clsx';
import React from 'react';
import { NumericFormat } from 'react-number-format';

interface NumberDisplayProps {
  name?: string;
  className?: string;
  thousandSeparator?: boolean;
  value: string | number;
  prefix?: string;
  displayType?: 'text' | 'input';
}

export const NumberDisplay = ({
  name,
  thousandSeparator = true,
  value,
  className = '',
  displayType = 'text',
  prefix = '$',
}: NumberDisplayProps) => {
  return (
    <NumericFormat
      displayType={displayType}
      decimalScale={5}
      value={value}
      name={name}
      //   className={clsx(className)}
      thousandSeparator={thousandSeparator}
      prefix={prefix}
      readOnly
    />
  );
};
